import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import Leads from './pages/leads/Leads'
import ProtectedRoute from './components/ProtectedRoute'
import React from 'react'
import Login from './Login'
import AppChakraProvider from './utils/Providers/AppChakraProvider'
import SupportTickets from './pages/support-ticket'


const App: React.FC = () => {
  return (
    <AppChakraProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                <Leads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support-tickets"
            element={
              <ProtectedRoute>
                <SupportTickets />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/leads" replace />} />
        </Routes>
      </Router>
    </AppChakraProvider>
  )
}

export default App
